import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import EkoElement from "@/utilities/element";
import style from "./command-menu-heading.css?inline";

@customElement("eko-command-menu-heading")
export class CommandMenuHeading extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  render() {
    return html`<slot></slot>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-command-menu-heading": CommandMenuHeading;
  }
}

export default CommandMenuHeading;
